import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AbstractStepDTO, SelectItem } from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-channel',
    templateUrl: './select-channel.component.html',
    styleUrls: ['./select-channel.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectChannelComponent),
            multi: true
        }],
    standalone: false
})
export class SelectChannelComponent implements OnInit, ControlValueAccessor {
  @Input() fieldId: string = 'fieldId'
  @Input() placeholder: string = 'components.select-channel.placeholder';
  @Input() disabled: boolean = false;
  @Input() dropdownClass: string = '';

  availableChannels: SelectItem[] = [];
  value: string = null;

  private onChange = (value: any) => { };
  private onTouched = () => { };

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.initializeOptions();
  }

  initializeOptions() {
    this.availableChannels = [{
      label: this.translate.instant(`components.select-channel.channel.${AbstractStepDTO.TypeEnum.SMS}`),
      value: AbstractStepDTO.TypeEnum.SMS
    },
    {
      label: this.translate.instant(`components.select-channel.channel.${AbstractStepDTO.TypeEnum.EMAIL}`),
      value: AbstractStepDTO.TypeEnum.EMAIL
    }]
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectionChange(event: any): void {
    this.value = event.value;
    this.onChange(this.value);
    this.onTouched();
  }
}
